var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgChevronDown = function SvgSvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12a1.994 1.994 0 0 1-1.414-.586l-8-8a1.998 1.998 0 0 1 0-2.828 1.998 1.998 0 0 1 2.828 0l6.61 6.61L16.61.836a2.002 2.002 0 0 1 2.78 2.878l-8 7.724C11 11.814 10.5 12 10 12Z",
    fill: "currentColor"
  })));
};
export default SvgSvgChevronDown;